import(/* webpackMode: "eager" */ "/app/hub/src/app/collections/error.tsx");
